import type { NewbornGuide } from "../types";
import familyFallCloseUpImage from "../../../assets/images/family-fall-close-up-portrait.webp";
import familySummerPicnicImage from "../../../assets/images/maternity-family-summer-picnic.webp";
import familyWoodlandWalkImage from "../../../assets/images/family-summer-park-walk-portrait.webp";
import family4 from "../../../assets/images/multigenerational-family-summer-picnic-portrait.webp";

export const familyGuides: NewbornGuide[] = [
  {
    eyebrow: "SESSION PREP",
    title: "How to Prepare for Your Family Photo Session",
    description: "A complete plan for a calm, organized and enjoyable photo day.",
    href: "/resources/family/how-to-prepare-for-your-family-photo-session/",
    imageAlt: "Family walking together on a wooded trail during an outdoor photo session",
    imageSrc: familyWoodlandWalkImage,
    tone: "peach",
  },
  {
    eyebrow: "SESSION TIMING",
    title: "Best Time of Day for Family Photos",
    description: "Balance beautiful light with your family's natural rhythm.",
    href: "/resources/family/best-time-of-day-for-family-photos/",
    imageAlt: "Family enjoying a summer picnic portrait in warm evening light",
    imageSrc: familySummerPicnicImage,
    tone: "sand",
  },
  {
    eyebrow: "STYLING GUIDE",
    title: "What to Wear for Family Photos",
    description: "Coordinate colors and textures without matching exactly.",
    href: "/resources/family/what-to-wear-for-family-photos/",
    imageAlt: "Family wearing coordinated warm fall colors for an outdoor portrait",
    imageSrc: familyFallCloseUpImage,
    tone: "cream",
  },
  {
    eyebrow: "HAPPY KIDS",
    title: "How to Prepare Kids for Family Photos",
    description: "Keep photo day relaxed, playful and low-pressure.",
    href: "/resources/family/how-to-prepare-kids-for-family-photos/",
    imageAlt: "Extended family enjoying a summer picnic in a field of daisies",
    imageSrc: family4,
    tone: "blush",
  },
  {
    title: "What Happens During a Family Photography Session?",
    description: "A natural mix of play, connection and guided portraits.",
    href: "/resources/family/what-happens-during-a-family-photography-session/",
    tone: "peach",
  },
  {
    title: "Best Outdoor Family Photo Locations in Charlotte",
    description: "Choose a location that fits your family and the season.",
    href: "/resources/family/best-outdoor-family-photo-locations-charlotte/",
    tone: "sand",
  },
  {
    title: "Extended Family Photo Session Guide",
    description: "Plan a smooth session with grandparents and multiple households.",
    href: "/resources/family/extended-family-photo-session-guide/",
    tone: "rose",
  },
  {
    title: "Fall Family Photos: What to Know Before You Book",
    description: "Timing, colors and practical planning for the busiest season.",
    href: "/resources/family/fall-family-photo-guide/",
    tone: "cream",
  },
];
